module.exports = __webpack_public_path__ + "img/iusful-logo.08021cbc.png";